import type {ReactElement, RefObject} from 'react';
import React from 'react';
import {getPosterDuration} from '@Components/poster-editor/poster-editor-reducer';
import {getStepSizeFromWidthPerSecond} from '@Components/poster-editor/components/poster-editor-web-bottom-bar/components/timestamps/timestamps.helper';
import {BaseTimestamps} from '@Components/poster-editor/components/poster-editor-web-bottom-bar/components/base-timestamps/base-timestamps';
import {useAppSelector} from '@/hooks';

interface TimestampsProps {
  initialDuration: number;
  totalDuration: number;
  timelineContainerRef: RefObject<HTMLDivElement | null>;
  widthPerSecond?: number;
}

export function Timestamps({widthPerSecond = 120, ...props}: TimestampsProps): ReactElement<any> | null {
  const posterDuration = useAppSelector(getPosterDuration);
  const durationWhileResizing = useAppSelector((state) => {
    return state.posterEditorWebBottomBar.durationWhileResizing;
  });
  const maxDurationWhileResizing = useAppSelector((state) => {
    return state.posterEditorWebBottomBar.maxDurationWhileResizing;
  });
  const isDesignItemResizing = useAppSelector((state) => {
    return state.posterEditorWebBottomBar.isDesignResizing;
  });

  if (!posterDuration) {
    return null;
  }

  return (
    <div className="_full-width _full-height spacing-p-t-1 spacing-p-l-2">
      <BaseTimestamps
        key={isDesignItemResizing ? durationWhileResizing : posterDuration}
        timelineContainerRef={props.timelineContainerRef}
        widthPerSecond={widthPerSecond}
        duration={isDesignItemResizing ? Math.max(durationWhileResizing, maxDurationWhileResizing, posterDuration) : posterDuration}
        stepSize={getStepSizeFromWidthPerSecond(widthPerSecond)}
      />
    </div>
  );
}
